module.exports = __webpack_public_path__ + "img/willhaben.9e97e6c5.svg";